import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./search-city.scss";

import SearchBar from "../../components/search-bar/search-bar";
import Loader from "../../components/loader/loader";
import LocationIcon from "../../assets/locationIcon.svg";
import CityCard from "../../components/city-card/city-card";
import ExitButton from "../../assets/exit.png";
import BackButton from "../../assets/backward.png";

import GetDiningCityAPI from "../../services/GetDiningCity/GetDiningCity";
import { pageUrl } from "../../utils/pageConstant";

const Search = () => {
  const navigate = useNavigate();
  const [popularCities, setPopularCities] = useState([]);
  const [isLoader, setIsLoader] = useState(true);

  useEffect(() => {
    getLocationCity();
  }, []);

  const getLocationCity = async () => {
    try {
      const responseData = await GetDiningCityAPI();
      setPopularCities(responseData);
      setIsLoader(false);
    } catch (error) {
      console.log("tokenValidate---", error);
    }
  };

  const handleNavigate = (city) => {
    navigate(pageUrl.SEARCH_LOCALITY, {
      state: { cityName: city },
    });
  };

  const onHandleBackBtn = () => {
    navigate("/outlet-list");
  };

  const onHandleCloseBtn = () => {
    navigate("/outlet-list");
  };

  return (
    <div className="search-page">
      {isLoader && <Loader />}
      <div className="cityPageControls">
        <img style={{height: "30px"}} src={BackButton} alt="x" onClick={onHandleBackBtn}/>
        <img style={{height: "30px"}} src={ExitButton} alt="x" onClick={onHandleCloseBtn}/>
      </div>
      <div className="search-header">You are looking to Dine-in</div>
      <div className="search-sub-header">
        Choose a city here which can be changed later on
      </div>
      {/* <SearchBar searchLabel="Type city here" handleNaviagte={handleNavigate} /> */}
      <div className="pop-city-text">Popular Cities</div>
      <div className="popular-city-section">
        {popularCities &&
          popularCities.map((city) => (
            <div
              key={city.city}
              className="popular-city"
              onClick={() => handleNavigate(city.city)}
            >
              <CityCard imgSrc={city.image} cardText={city.city} />
            </div>
          ))}
      </div>
    </div>
  );
};

export default Search;
